export default __webpack_public_path__ + "static/media/ETEF-20-21.2be4d5b8.pdf";